import { UIDateFormat, UITimeFormat } from "@helpers/dates";
import React from "react";
import { DateInput, TimeInput } from "semantic-ui-calendar-react";

const DateTimeSelect = (props) => {
  const { label, name, value, disabled, handleDateChange, handleTimeChange } =
    props;

  return (
    <>
      <DateInput
        icon={false}
        name={name}
        label={label}
        compact
        placeholder="Date"
        value={value.format(UIDateFormat)}
        onChange={handleDateChange}
        animation="fade"
        popupPosition="bottom center"
        disabled={disabled}
        autoComplete="off"
        className="p-0 hide-label"
        style={{ width: "90px" }}
      />
      <TimeInput
        name={name}
        icon={false}
        placeholder="Time"
        value={value.format(UITimeFormat)}
        onChange={handleTimeChange}
        className="p-0 hide-label mr-0_5 ml-0_5"
        animation="fade"
        popupPosition="bottom center"
        disabled={disabled}
        style={{ width: "56px" }}
        autoComplete="off"
      />
    </>
  );
};

export default DateTimeSelect;
